import { useContext } from 'react';

import AuthPopupContext from './AuthPopupContext';

const useAuthPopup = () => useContext(AuthPopupContext);

export default useAuthPopup;
